import { SET_BUSY_MESSAGE, SET_LIMIT_MESSAGE } from '../Messages/constants';
import {
  FETCH_SUGGESTIONS,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_ERROR,
} from './constants';
import axios from 'axios';

export const BUSY_MESSAGE =
    "Sorry to keep you waiting, I'll respond to you as soon as possible!";
export const LIMIT_MESSAGE =
    'As the saying goes, all good things must come to an end… Thank you for interacting with me. I hope I was able to impress you!';


export const fetchSuggestions = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_SUGGESTIONS });

  const state = getState();
  const { apiUrl, apiKey, tenant } = state.Config;

  let suggestions = [];

  try {
    const response = await axios.get(
      `${apiUrl}/ema/suggestions?tenant=${tenant}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
      },
    );
    console.log('Data fetched from API:', response.data);
    suggestions = response.data.prompts || [];
    dispatch({ type: FETCH_SUGGESTIONS_SUCCESS, payload: suggestions });


    dispatch({ type: SET_BUSY_MESSAGE, payload: BUSY_MESSAGE });
    dispatch({ type: SET_LIMIT_MESSAGE, payload: LIMIT_MESSAGE });
  } catch (error) {
    dispatch({ type: FETCH_SUGGESTIONS_ERROR, payload: suggestions });
    console.error('Error fetching suggestions:', error.message);
  }
};
